export default __webpack_public_path__ + "static/media/audio.b6eac012.svg";